import React, { useEffect } from "react";
import { Alert } from "antd";
import { Icon } from "Components";
import "./toast.scss";

interface CampaignLimitToastProps {
    visible: boolean;
    message: string;
    onClose: () => void;
    type?: "success" | "warning";
    icon?: "campaignInfo" | "check"
}

const CampaignLimitToast: React.FC<CampaignLimitToastProps> = ({
    visible,
    message,
    onClose,
    type = "warning",
    icon = "campaignInfo"
}) => {

    useEffect(() => {
		if (!message) return;
		const timer = setTimeout(onClose, 3000);
		return () => clearTimeout(timer);
	}, [message]);

    if (!visible) return null;

    return (
        <Alert
            message={message}
            type={type}
            showIcon
            closable
            onClose={onClose}
            icon={<Icon type={icon} />}
            closeText={<Icon type="close" />}
            className={`custom-toaster ${type} ${icon}`}
        />
    );
};

export default CampaignLimitToast;